import { useState } from "react";
import styled from "@emotion/styled";

import { BasicFlex } from "../../utils/Common";

import WarningRoundedIcon from '@mui/icons-material/WarningRounded';


let WmContainer = styled(BasicFlex)`
  padding: 1.6rem;
`

let WMessage = styled(BasicFlex)`
  width: auto;
  gap: 2rem;
  align-items: flex-start;
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: .6px;
  font-weight: 600;

  .icon {
    width: fit-content;
  }

  .message {
    flex-grow: 1;
  }
`
const WarningMessage = () => {
  return <WmContainer dir="column" gap="2rem">
    <div>
      This action cannot be undone. Are you sure you want to delete this?
    </div>
    
    <WMessage>
      <div className="icon">
        <WarningRoundedIcon color="warning" fontSize="large" />
      </div>
      <div className="message">Warning! All Repairs and Custom Orders attached to this invoice will be permanently deleted. Please make sure this is what you want to do.</div>
    </WMessage>
  </WmContainer>
};

export { WarningMessage };